import { AlignmentTransform } from "@/modes/alignment-modes-commons/alignment-transform";
import { TwoPointsPairsAlignmentAnchorPositions } from "@/modes/alignment-modes-commons/compute-split-screen-alignment";
import {
  AlignmentViewLayout,
  SplitDirection,
} from "@/store/modes/alignment-ui-types";
import { RootState } from "@/store/store";
import {
  SheetCadAlignmentStep,
  SheetCadAlignReference,
} from "./sheet-cad-alignment-mode-slice";

/**
 * @returns the current sheet CAD alignment reference
 */
export function selectSheetCadAlignmentReference({
  sheetCadAlignmentMode,
}: RootState): SheetCadAlignReference {
  return sheetCadAlignmentMode.alignmentReference;
}

/**
 * @returns the current sheet and CAD alignment step
 */
export function selectSheetCadAlignmentStep({
  sheetCadAlignmentMode,
}: RootState): SheetCadAlignmentStep {
  return sheetCadAlignmentMode.step;
}

/**
 * @returns the current sheet and CAD alignment screen layout
 */
export function selectSheetCadAlignmentLayout({
  sheetCadAlignmentMode,
}: RootState): AlignmentViewLayout {
  return sheetCadAlignmentMode.alignmentLayout;
}

/**
 * @returns the current sheet and CAD alignment vertical split flag
 */
export function selectSheetCadAlignmentSplitDirection({
  sheetCadAlignmentMode,
}: RootState): SplitDirection {
  return sheetCadAlignmentMode.splitDirection;
}

/**
 * @returns true if Clipping box for first step of sheet and CAD alignment is enabled
 */
export function selectClippingBoxEnabledForSheetCadAlignment({
  sheetCadAlignmentMode,
}: RootState): boolean {
  return sheetCadAlignmentMode.isClippingBoxEnabled;
}

/**
 * @returns true if cross section for CAD tomographic view is enabled
 */
export function selectCrossSectionEnabledForTomographicView({
  sheetCadAlignmentMode,
}: RootState): boolean {
  return sheetCadAlignmentMode.isCrossSectionEnabled;
}

/**
 * @param state  Current state
 * @returns incremental transform in CS of previous pose or undefined if position/scale was not modified
 */
export function selectIncrementalSheetCadTransform(
  state: RootState,
): AlignmentTransform | undefined {
  return state.sheetCadAlignmentMode.incrementalTransform;
}

/**
 * @param state  Current state
 * @returns  Elevation of sheet plane relatively to CAD origin in W.C.S., in meters
 */
export function selectSheetElevation(state: RootState): number {
  return state.sheetCadAlignmentMode.sheetElevation;
}

/**
 * @param state  Current state
 * @returns  id of sheet used in  current session of sheet and CAD alignment
 */
export function selectSheetForSheetCadAlignment(
  state: RootState,
): string | undefined {
  return state.sheetCadAlignmentMode.sheetIdForAlignment;
}

/**
 * @param state  Current state
 * @returns  anchor positions in split screen cad alignment
 */
export function selectAlignmentAnchorPositions(
  state: RootState,
): TwoPointsPairsAlignmentAnchorPositions {
  return state.sheetCadAlignmentMode.alignmentAnchorPositions;
}
